// API base URL.
//
// Resolution order:
//   1. REACT_APP_API_BASE_URL (preferred — set per environment via .env)
//   2. Legacy hostname-based fallback so existing deploys keep working when
//      no env var is provided.
//
// Trailing slashes are stripped so callers can compose with `/path` safely.

const DEFAULT_DEV_API = "https://devportal.letsgetvisa.com/api";
const DEFAULT_LOCAL_API = "http://localhost:8081/api";

const fromEnv = process.env.REACT_APP_API_BASE_URL?.trim();

function resolveFromHostname(): string {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  if (hostname === "localhost") return DEFAULT_LOCAL_API;
  return DEFAULT_DEV_API;
}

const API_BASE_URL: string = (fromEnv || resolveFromHostname()).replace(/\/$/, "");

export default API_BASE_URL;
